<template>
  <div class="sell-card" v-title data-title="销卡详情">
    <header>
      <div class="content-top">
        <!-- 时间选项 -->
        <div class="date-option">
          <img src="../../assets/images/partner-img/partner-information/21.png" alt="" class="icon">
          <span>
            已销数量：{{team_list.number}}
          </span>
        </div>
      </div>
    </header>
    <section>
      <div class="share-option-list" v-for="(item,index) in team_list.list" :key="index">
        <div class="share-option-list-content">
          <div class="touxiang">
            <img :src="item.avatar" alt="">
          </div> 
          <div class="msg1">
            <span>
              {{item.user_nickname}}
            </span>
          </div>
          <div class="msg2">
            <span>
              {{item.pubdate}}
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      team_list: [], // 佣金列表
      uid : ''
    };
  },
  created(){
    // 佣金
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/user/index/sell_card",{
      uid : this.uid,
    }).then((res) => {
      // console.log(res)
      this.team_list = res.data.data
    })
  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
  .sell-card{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background: #f4f4f4;
    header{
      .content-top{
        width: 7.5rem;
        height: 1.29rem;
        overflow: hidden;
        .date-option{
          height: 1.29rem;
          display: flex;
          align-items: center;
          float: left;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #212121;
          img{
            width: .3rem;
            height: .32rem;
            margin-left: .4rem;
            margin-right: .14rem;
          }
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: center;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.68rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          .touxiang{
            width: .94rem;
            height: 1.68rem;
            float: left;
            margin-right: .1rem;
            display: flex;
            align-items: center;
            img{
              width: .94rem;
              height: .94rem;
              border-radius: 50%;
            }
          }
          .msg1{
            height: 1.68rem;
            float: left;
            display: flex;
            align-items: center;
            margin-left: .13rem;
            span{
              font-size: 0.3rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #212121;
            }
          }
          .msg2{
            height: 1.68rem;
            float: right;
            display: flex;
            align-items: center;
            span{
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #919191;
            }
          }
        }
      }
    }
  }
</style>